import { render, staticRenderFns } from "./select-estados.vue?vue&type=template&id=1cabe653&"
import script from "./select-estados.vue?vue&type=script&lang=js&"
export * from "./select-estados.vue?vue&type=script&lang=js&"
import style0 from "./select-estados.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports